import { c as _c } from "react/compiler-runtime";
import { Box, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
const carouselLoop = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) translateX(34px) scale(0.92) rotate(-2deg);
  }
  12% {
    opacity: 0.8;
    transform: translate(-50%, -50%) translateX(18px) scale(0.96) rotate(-1.2deg);
  }
  23% {
    opacity: 1;
    transform: translate(-50%, -50%) translateX(0px) scale(1) rotate(0deg);
  }
  33% {
    opacity: 1;
    transform: translate(-50%, -50%) translateX(-8px) scale(1) rotate(0.2deg);
  }
  48% {
    opacity: 0.6;
    transform: translate(-50%, -50%) translateX(-20px) scale(0.97) rotate(1deg);
  }
  60% {
    opacity: 0;
    transform: translate(-50%, -50%) translateX(-34px) scale(0.93) rotate(1.4deg);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) translateX(-34px) scale(0.93) rotate(1.4deg);
  }
`;
const cards = [{
  name: 'Shannon, 28',
  gradient: 'linear(to-b, #fef8e7 0%, #f7c96c 45%, #f2a93f 100%)',
  image: require('@public/assets/graphics/social/animation-card-1.jpeg').default.src
}, {
  name: 'Jules, 31',
  gradient: 'linear(to-b, #fff4f2 0%, #ffa6a0 45%, #f7796d 100%)',
  image: require('@public/assets/graphics/social/animation-card-2.jpeg').default.src
}, {
  name: 'Maya, 26',
  gradient: 'linear(to-b, #eef9ff 0%, #8fd7ff 45%, #57b9ef 100%)',
  image: require('@public/assets/graphics/social/animation-card-3.jpeg').default.src
}] as const;
export const BumbleCarousel: React.FC = () => {
  const $ = _c(6);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      base: "470px",
      md: "540px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isMobile ? 20 : 10;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      base: "240px",
      md: "280px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      perspective: "1200px",
      transformStyle: "preserve-3d"
    };
    t4 = cards.map(_temp);
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1) {
    t5 = <Box height={t0} marginBottom={t1} overflow="visible" position="relative" transform="rotateX(7deg) rotateY(-11deg)" width={t2} zIndex={10} css={t3}>{t4}</Box>;
    $[4] = t1;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default BumbleCarousel;
function _temp(card, index) {
  return <Box key={card.name} animation={`${carouselLoop} 7.5s ease-in-out ${index * 2.5}s infinite`} bgPos="center" bgRepeat="no-repeat" bgSize="cover" border="1px solid rgba(255, 255, 255, 0.4)" borderRadius="34px" height={{
    base: "395px",
    md: "470px"
  }} left="50%" opacity={0} position="absolute" top="50%" width={{
    base: "210px",
    md: "250px"
  }} _after={{
    content: "\"\"",
    position: "absolute",
    top: "28px",
    left: "22px",
    width: "120px",
    height: "8px",
    borderRadius: "full",
    bg: "rgba(255, 255, 255, 0.5)"
  }} _before={{
    content: "\"\"",
    position: "absolute",
    top: "18px",
    right: "18px",
    width: "58px",
    height: "58px",
    borderRadius: "full",
    bg: "rgba(255, 255, 255, 0.32)",
    filter: "blur(1px)"
  }} boxShadow="0 20px 40px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -80px 120px rgba(0, 0, 0, 0.18)" overflow="hidden" bgImage={`url(${card.image})`}><Box inset={0} position="absolute" bg="linear-gradient(to bottom, transparent 10%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.45) 100%)" /><Text bottom={5} color="white" fontFamily="Poppins, sans-serif" fontSize={{
      base: "sm",
      md: "md"
    }} fontWeight={700} left={5} letterSpacing="0.01em" position="absolute" textShadow="0 2px 8px rgba(0,0,0,0.3)">{card.name}</Text></Box>;
}